'use client';

import { useEffect } from 'react';
import { redirect } from 'next/navigation';
import { useGetAccessQuery } from '@cntxt/data-access/access-control';
import { useSession } from '@cntxt/shared/infrastructure/session';
import { hasErrorResponse } from '@cntxt/shared/utilities/errors';
import { RedirectToKeycloak } from './components/RedirectToKeycloak';
const SignInPage = () => {
  const session = useSession();
  const {
    data: access
  } = useGetAccessQuery(session);
  useEffect(() => {
    if (hasErrorResponse(access)) {
      console.log('Error in access user access!');
      return;
    }
    if (session.data && access?.homepage) {
      console.log('Redirecting to homepage:', access.homepage);
      redirect(access.homepage);
    }
    // these are the right deps, adding ignore to stop lint warnings
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.status, access]);

  // Always navigate to keycloak
  return <RedirectToKeycloak />;
};
export default SignInPage;